/**
 * Phase 2: 並列データ取得
 *
 * questionnaire を取得する parallel state。
 * campaign / popup / masterUpdate は phase1 で取得済みのためここでは不要。
 * 全サブステートが final に到達したら phase3 へ遷移する。
 */
export const phase2ParallelConfig = {
  type: 'parallel' as const,
  states: {
    // 2.A ログインアンケート（認証済みかつ idToken が store にある場合のみ取得）
    questionnaire: {
      initial: 'checking' as const,
      states: {
        checking: {
          always: [
            { target: 'checkingToken' as const, guard: 'isAuthenticated' as const },
            { target: 'skipped' as const },
          ],
        },
        // idToken の読み込み完了（loading: false）を待ってから fetch に進む。
        // waitForTokenLoad アクターが useTokenStore.loading の変化を購読し、
        // false になった時点で解決する。token がなければ skipped にフォールバック。
        checkingToken: {
          invoke: {
            src: 'waitForTokenLoad' as const,
            onDone: [
              { target: 'fetching' as const, guard: 'hasTokenInStore' as const },
              { target: 'skipped' as const },
            ],
          },
        },
        fetching: {
          invoke: {
            src: 'fetchQuestionnaire' as const,
            onDone: {
              target: 'done' as const,
              actions: 'assignQuestionnaireResult' as const,
            },
            onError: 'done' as const,
          },
        },
        done: { type: 'final' as const },
        skipped: { type: 'final' as const },
      },
    },
  },
  onDone: 'phase3' as const,
}
